// SPDX-License-Identifier: Apache-2.0

import { jsonMember, jsonObject } from "typedjson";
import { MessageType, MessageTypeName } from "./messageTypes";
import PerunMessage from "./PerunMessage";
import {
  ChannelAsset,
  deserializeChannelAsset,
  serializeChannelAsset,
} from "./types/channelState";

@jsonObject()
export default class GetBalance extends PerunMessage {
  @jsonMember({
    deserializer: deserializeChannelAsset,
    serializer: serializeChannelAsset,
  })
  asset: ChannelAsset;

  constructor(asset: ChannelAsset) {
    super();
    this.asset = asset;
  }

  messageType(): MessageType {
    return GetBalance;
  }

  messageTypeName(): MessageTypeName {
    return "GetBalance";
  }
}
